import "core-js/modules/es.array.concat.js";
import { asyncImportScript } from 'integration-web-core--socle/js/assets/modules/_asyncImportScript';
import { hitEventsTms } from 'integration-web-core--socle/js/assets/commons/_tms.js';
import VideoCore from 'integration-web-core--socle/js/assets/modules/_video.class';
import Utils from '../utils/Utils';
export default (function () {
  var video = document.querySelector('.video-js');
  if (video) {
    if (video.classList.contains('video-js--youtube')) {
      new VideoCore();
    } else {
      var _video$dataset = video.dataset,
        account = _video$dataset.account,
        player = _video$dataset.player;
      asyncImportScript("//players.brightcove.net/".concat(account, "/").concat(player, "_default/index.min.js"));
    }
  }
});